import Cookies from 'js-cookie';

const defaults = {
  domain: process.env.REACT_APP_DOMAIN,
  expires: 7, // in days
};

export function getCookie(name: string) {
  const cookie = Cookies.get(name);
  return cookie;
}

export function getJSONCookie(name: string) {
  const cookie = Cookies.getJSON(name);
  return cookie;
}

export function removeCookie(name: string) {
  Cookies.remove(name, defaults);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function setCookie(name: string, value: string | object) {
  const cookie = Cookies.set(name, value, defaults);
  return cookie;
}
